import instance from "../utils/request.js"
import { getRequest } from "../utils/request.js"

/*获取图片信息*/
export function GetPicture(data = {}){
return instance.request({
        method: "get",
        url: "basicdata/picture/",
        params:data
    })
}


/*获取图片编辑信息*/
export function PictureEditInfo(data = {}){
return instance.request({
        method: "get",
        url: "basicdata/pictureedit/",
        params:data
    })
}

/*图片编辑*/
export function PictureEdit(data = {}){
    let params = new URLSearchParams();
    params.append('pictureid',data.pictureid);
    params.append('picturename',data.picturename);
    params.append('picturenumber',data.picturenumber);
    params.append('state',data.state);
    params.append('notes',data.notes);
    params.append('material',data.material);
return instance.request({
        method: "post",
        url: "basicdata/pictureedit/",
        data:params
    })
}


/*图片新增*/
export function PictureAdd(data = {}){
return instance.request({
        method: "post",
        url: "basicdata/pictureadd/",
        data:data
    })
}

/*图片删除*/
export function PictureDel(data = {}){
    let params = new URLSearchParams();
    params.append('pictureid',data.pictureid)
return instance.request({
        method: "post",
        url: "basicdata/picturedel/",
        data:params
    })
}

/*获取所有角色信息*/
export function CategoryInfo(data = {}){
return instance.request({
        method: "get",
        url: "basicdata/categoryoptions/",
        params:data
    })
}
